const getAll = (state) => {
  return state
}

const getPayment = (state) => {
  return state.summary.payments
}

const getPaymentSaldo = (state) => {
  return state.summary.payments.saldo
}

const getPayoutPossibility = (state) => {
  return state.summary.payments.payout_possibility
}

const getCalculations = (state) => {
  return state.summary.calculations
}

const getPending = (state) => {
  return state.summary.pending
}

const getHistory = (state) => {
  return state.history
}

const getCalculationHistory = (state) => {
  return state.history.calculations
}

const getPendingHistory = (state) => {
  return state.history.pending
}
const getTranches = (state) => {
  return state.tranches
}

export default {
  getAll,
  getPending,
  getPayment,
  getPaymentSaldo,
  getPayoutPossibility,
  getCalculations,
  getHistory,
  getCalculationHistory,
  getPendingHistory,
  getTranches
}



// WEBPACK FOOTER //
// ./src/store/modules/statistics/getters.js